import { Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
  ChangeDetectorRef, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Location } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { F8865SchM2K1SourcingService } from '../../services/f8865-sch-m2-k1-sourcing.service';
import { F8865SchM2K1SourcingModel } from '../../models/f8865-sch-m2-k1-sourcing-model';
import { UserService } from '../../../screen-video-container/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { IssueModel } from '../../models/issue-model';
import { cloneDeep, toNumber } from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';



@Component({
    selector: 'gtw-f8865-sch-m2-k1-sourcing',
    templateUrl: './f8865-sch-m2-k1-sourcing.component.html',
    styleUrls: ['./f8865-sch-m2-k1-sourcing.component.scss'],
    providers: [CurrencyPipe],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class F8865SchM2K1SourcingComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  private baseURL = '/custom';
  private baseURLGtw = '/gtw';
  private taxYear :number = 0;
  private scenario :number = 0;
  private jcdKey :number = 0;
  private screenKey :number = 0;
  private ssoId: string = '';
  private hoCombinationKey: number = 0;
  private acctType: string = '';
  private scenarioCode : string = '';
  private isIssueKeyEnabled: string = '';

  private totalTOTAL :number = 0;
  private totalBRANCH :number = 0;
  private totalGENERAL :number = 0;
  private totalFSI :number = 0;
  private totalPASSIVE :number = 0;
  private totalUS :number = 0;
  private checkLockedObj: any = [];

  public toolTipMsgAdd = "Add New Sourcing";
  public toolTipMsgRemove = "Remove Existing Sourcing";

  modalTitle = '';
  minimise = false;
  scenarioLabel = '';

  clob_settings:any = {};
  clob_data:any = [];

  public validationErrMsg:string = '';

  private route: string = '';
  isLoading = false;

  GENERAL_CONFIG: any = {};
  globalParams: any = {};
  USER_SETTINGS: any = {};
  SERVER_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  @Output('open-sourcing-basket-list')
  openSourcingBasketList = new EventEmitter<string>();

  @Output('save-partnership-sourcing')
  savePartnershipSourcing = new EventEmitter<string>();


  sourcingList : any = [];

  issueList : Array<IssueModel> = [];

  firstList:any = [];

  row:any = [];

  durationInSeconds = 5;

  myScenarioCode: string = '';

  rowsEdited:any = [];
  rowsAdded:any = [];
  rowsDeleted:any = [];

  private readonly subs = new Subscription();

  constructor(
    private userService: UserService,
    private f8865SchM2K1SourcingService: F8865SchM2K1SourcingService,
    private _snackBar: MatSnackBar,
    location: Location,
    router: Router,
    private currencyPipe: CurrencyPipe,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subs.add(
      router.events.subscribe((val) => {
        if (location.path() != '') {
          this.route = location.path();
        } else {
          this.route = 'Home';
        }
      })
    );
  }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const activeData = activeScreen?.data || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.SERVER_CONFIG = this.gtwApp.SERVER_CONFIG || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow) ? extractObject(rawRow[0]) : extractObject(rawRow);

    this.baseURL = this.GENERAL_CONFIG.custom || '/custom';
    this.baseURLGtw = this.GENERAL_CONFIG.api || '/gtw';
    this.taxYear = this.globalParams?.tax_year || this.filterParams?.tax_year || 0;
    this.scenario = this.globalParams?.scenario || this.filterParams?.scenario || 0;
    this.jcdKey = this.globalParams?.jcd_key || this.filterParams?.jcd_key || 0;
    this.screenKey = this.globalParams?.screen_key || this.filterParams?.screen_key || 0;
    this.ssoId = this.globalParams?.sso_id || this.USER_SETTINGS?.user?.sso_id || '';
    this.hoCombinationKey = this.rowData?.HO_COMBINATION_KEY || this.rowData?.COMBINATION_KEY || this.filterParams?.ho_combination_key || 0;
    this.acctType = this.rowData?.ACCT_TYPE || this.filterParams?.acct_type || '';
    this.scenarioCode = this.globalParams?.scenarioCode || this.globalParams?.scenario_code || this.filterParams?.scenarioCode || '';
    this.isIssueKeyEnabled = this.globalParams?.is_issue_key_enabled || 'N';
    this.checkLockedObj = activeData?.checkLockedObj || activeData?.check_locked_obj || [];

    this.scenarioLabel = this.filterParams?.scenarioLabel || this.filterParams?.scenario_label
      || this.globalParams?.scenario_desc || this.globalParams?.scenarioLabel || 'Return As Filed';
    this.modalTitle = `Edit 8865 M-2/K-1 Partnership Sourcing ( Tax Year : ${this.taxYear} - Scenario : ${this.scenarioLabel} )`;
    this.cdr.markForCheck();
  }

  init() {
    if(this.checkInputType()){
    this.getIssueList();
    this.getSourcingDetails();
    }
  }

  addDollarSign(text: string) {
    return '$ ' + text
  }

  // Only Integer Numbers
  keyPressNumbers(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9 and minus
    if(charCode == 45 || charCode == 48 || charCode == 49 || charCode == 50 || charCode == 51 || charCode == 52 || charCode == 53 || charCode == 54 || charCode == 55 || charCode == 56 || charCode == 57) {
      return true;
    }
    else {
      event.preventDefault();
      return false;
    }

  }

  checkInputType():boolean{
    if(Number.isInteger(parseInt(this.taxYear+"")) &&
      Number.isInteger(parseInt(this.scenario+'')) &&
      Number.isInteger(parseInt(this.jcdKey +'')) &&
      Number.isInteger(parseInt(this.screenKey+'')) &&
      Number.isInteger(parseInt(this.hoCombinationKey+'')) &&
        (this.acctType === "ASSETS" || this.acctType === "INCOME" || this.acctType === "DEDUCTIONS" || this.acctType === "PRIOR_ASSETS") &&
      (this.scenarioCode === "RAF" || this.scenarioCode === "QAR" || this.scenarioCode === "RAF1") &&
      (this.isIssueKeyEnabled == "Y" || this.isIssueKeyEnabled == "N")
    )
    {
      return true;
    }

    return false;
  }

  getIssueList() {

    this.f8865SchM2K1SourcingService.getIssueList(this.baseURLGtw, this.taxYear, this.scenario, this.jcdKey).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: Array<IssueModel>) => {
        if (data) {
          this.issueList = data;
          console.log(data, 'issue data');

        }
      },
      error => {
        this.isLoading = false;
        console.log(error);
      }, () => {
        this.isLoading = false;
      });
  }


  getSourcingDetails() {
    console.log('Get Console Data Called.');
    if(this.sourcingList.length == 0 && !this.isLoading) {
      this.isLoading = true;

      this.f8865SchM2K1SourcingService.getF8865M2K1SourcingList(this.baseURLGtw, this.taxYear, this.scenario, this.jcdKey, this.screenKey, this.hoCombinationKey, this.acctType, this.ssoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: F8865SchM2K1SourcingModel) => {
          if (data) {
            this.isLoading = false;

            this.sourcingList = data;
            this.firstList.push(this.sourcingList[0]);
            this.myScenarioCode = this.sourcingList[0].SCENARIO_CODE;
            this.checkLockedObj = [{
              leid: this.sourcingList[0].HO_LEID || '',
              cdr_number: this.sourcingList[0].HO_CDR_NO || '',
              reporting_period: this.sourcingList[0].HO_REPORTING_PERIOD || '',
              combination_key: this.sourcingList[0].COMBINATION_KEY || this.hoCombinationKey,
              scenario_key: this.scenario
            }];
            console.log(data, 'data');

            //this.hoCombinationKey = this.firstList[0].COMBINATION_KEY;
            //this.acctType = this.firstList[0].ACCT_TYPE;
          }
        },
        error => {
          this.isLoading = false;
          console.log(error);
        }, () => {
          this.isLoading = false;
          console.log('Completed all tabs');
        });

    }

  }

   isValidNumber(input: string) {
    input = input+'';
    if( (input.match(new RegExp("-", "g")) || []).length === 0 || ( (input.match(new RegExp("-", "g")) || []).length === 1 && input.indexOf('-') == 0 ) ) {
      return true;
    }
    else return false;
  }

  makeDirty(row: number) {
    this.sourcingList[row].IS_DIRTY = 'Y';
  }


  refreshSourcingTotal(basket:string, row : number) {

    for(let i = 0; i < this.sourcingList.length; i++) {

      if(i === row) {

        if(basket === "GENERAL") {
          if(this.sourcingList[i].GENERAL === '' || this.sourcingList[i].GENERAL === '-' || !this.isValidNumber(this.sourcingList[i].GENERAL)) {
            this.sourcingList[i].GENERAL = "0";
          }
        }
        else if(basket == "FSI") {
          if(this.sourcingList[i].FSI === '' || this.sourcingList[i].FSI === '-' || !this.isValidNumber(this.sourcingList[i].FSI))
            this.sourcingList[i].FSI = "0";
        }
        else if(basket == "PASSIVE") {
          if(this.sourcingList[i].PASSIVE === '' || this.sourcingList[i].PASSIVE === '-' || !this.isValidNumber(this.sourcingList[i].PASSIVE))
            this.sourcingList[i].PASSIVE = "0";
        }
        else if(basket == "US") {
          if(this.sourcingList[i].US === '' || this.sourcingList[i].US === '-' || !this.isValidNumber(this.sourcingList[i].US))
            this.sourcingList[i].US = "0";
        }
        this.sourcingList[i].BRANCH = this.sourcingList[i].TOTAL - ( Number(this.sourcingList[i].GENERAL) +  Number(this.sourcingList[i].FSI) + Number(this.sourcingList[i].PASSIVE) + Number(this.sourcingList[i].US) );
        break;
      }
    }
    this.calcTotal(basket);
    this.calcTotal('BRANCH');
  }


  calcTotal(basket:string){

    if(basket === "TOTAL")
      this.totalTOTAL = 0;
    if(basket === "BRANCH")
      this.totalBRANCH = 0;
    if(basket === "GENERAL")
      this.totalGENERAL = 0;
    if(basket === "FSI")
      this.totalFSI = 0;
    if(basket === "PASSIVE")
      this.totalPASSIVE = 0;
    if(basket === "US")
      this.totalUS = 0;

    for (let i = 0; i < this.sourcingList.length; i++) {
      this.row = this.sourcingList[i];
      if(basket === "TOTAL") {
        this.totalTOTAL = Number(this.totalTOTAL) + Number(this.row.TOTAL);
      }
      if(basket === "BRANCH") {
        this.totalBRANCH = Number(this.totalBRANCH) + Number(this.row.BRANCH);
      }
      if(basket === "GENERAL") {
        this.totalGENERAL = Number(this.totalGENERAL) + Number(this.row.GENERAL);
      }
      if(basket === "FSI") {
        this.totalFSI = Number(this.totalFSI) + Number(this.row.FSI);
      }
      if(basket === "PASSIVE") {
        this.totalPASSIVE = Number(this.totalPASSIVE) + Number(this.row.PASSIVE);
      }
      if(basket === "US") {
        this.totalUS = Number(this.totalUS) + Number(this.row.US);
      }

    }
    if(basket === "TOTAL") {
      return this.totalTOTAL;
    }
    if(basket === "BRANCH") {
      return this.totalBRANCH;
    }
    if(basket === "GENERAL") {
      return this.totalGENERAL;
    }
    if(basket === "FSI") {
      return this.totalFSI;
    }
    if(basket === "PASSIVE") {
      return this.totalPASSIVE;
    }
    if(basket === "US") {
      return this.totalUS;
    }
    else {
      return 0;
    }
  }

  addSourcingRecord() {
    let sourcingRecord:any = {};
    sourcingRecord = cloneDeep(this.sourcingList[0]);

    sourcingRecord['OP_MODE'] = 'add';
    sourcingRecord['IS_DIRTY'] = 'Y';
    sourcingRecord['ISSUE_KEY'] = -1;
    sourcingRecord['ISSUE_SHORT_DESC'] = '';
    sourcingRecord['ISSUE_ID_SHORT_DESC']= '';
    sourcingRecord['TOTAL'] = 0;
    sourcingRecord['BRANCH'] = 0;
    sourcingRecord['GENERAL'] = 0;
    sourcingRecord['FSI'] = 0;
    sourcingRecord['PASSIVE'] = 0;
    sourcingRecord['US'] = 0;


    console.log('sourcingRecord = ', sourcingRecord);
    this.sourcingList.push(sourcingRecord);
  }

  removeSourcingRecord(row:number) {
    let sourcingRecord:any = {};
    sourcingRecord = cloneDeep(this.sourcingList[row]);
    if(sourcingRecord.OP_MODE === 'edit') {
      sourcingRecord.OP_MODE = 'delete';
      sourcingRecord.IS_DIRTY = 'Y';
      this.rowsDeleted.push(sourcingRecord);
    }
    this.sourcingList.splice(row,1);

  }

  private openSnackBar(message: string) {
    this._snackBar.open(message, '' , {
      duration: this.durationInSeconds * 1000,
    });
  }

  onIssueChange(event: any, row:number) {
    console.log('Issue changed...');
    let selectedIssue = event.value;
    console.log(selectedIssue);
    this.sourcingList[row].ISSUE_KEY = selectedIssue;
  }

  saveF8865M2K1SourcingData() {
    console.log('Save button clicked.');

    this.clob_settings = {};
    this.clob_data = [];
    this.rowsAdded = [];
    this.rowsEdited = [];

    this.clob_settings['tax_year'] = this.taxYear;
    this.clob_settings['scenario'] = this.scenario;
    this.clob_settings['jcd_key'] = this.jcdKey;
    this.clob_settings['screen_key'] = this.screenKey;
    this.clob_settings['sso_id'] = this.ssoId;

    this.clob_settings['ho_combination_key'] =  this.hoCombinationKey;
    this.clob_settings['acct_type'] = this.acctType;

    for(let i = 0; i < this.sourcingList.length; i++) {
      let sourcingRecord: any = {};
      sourcingRecord = this.sourcingList[i];
      console.log(' sourcingRecord = ', sourcingRecord);
      if (sourcingRecord.OP_MODE === 'edit' && sourcingRecord.IS_DIRTY === 'Y') {
        this.rowsEdited.push(sourcingRecord);
        console.log('this.rowsEdited = ', this.rowsEdited);
      }
      else if(sourcingRecord.OP_MODE === 'add' && sourcingRecord.IS_DIRTY === 'Y') {
        this.rowsAdded.push(sourcingRecord);
        console.log('this.rowsAdded = ', this.rowsAdded);
      }
    }

    if(this.rowsAdded.length > 0) {
      for(let i = 0; i < this.rowsAdded.length; i++) {
        this.clob_data.push(this.rowsAdded[i]);
      }
    }

    if(this.rowsEdited.length > 0) {
      for(let i = 0; i < this.rowsEdited.length; i++) {
        this.clob_data.push(this.rowsEdited[i]);
      }
    }

    if(this.rowsDeleted.length > 0) {
      for(let i = 0; i < this.rowsDeleted.length; i++) {
        this.clob_data.push(this.rowsDeleted[i]);
      }
    }


    console.log('clob_settings = ' , this.clob_settings);
    console.log('clob_data = ' , this.clob_data);

    if (this.validate() == true) {

      let updateSubscription = this.f8865SchM2K1SourcingService.saveF8865M2K1SourcingData(this.baseURLGtw,this.taxYear,this.scenario, this.jcdKey, this.screenKey, this.ssoId, this.scenarioCode, this.isIssueKeyEnabled, this.checkLockedObj, this.clob_settings, this.clob_data).subscribe(
        (response)=>{
          this.isLoading =false;
          if(response.callSuccess == "1") {
            this.f8865SchM2K1SourcingService.openSnackBar('Sourcing Data Saved','gtw-snackbar--green');
            this.savePartnershipSourcing.emit('save-partnership-sourcing');
            this.requestGridUpdate.emit('refresh');
          } else {
            this.f8865SchM2K1SourcingService.openSnackBar('Error Saving Sourcing Data. '+response.errorMessage, 'gtw-snackbar--red');
          }
        },
        error => { this.isLoading =false;this.f8865SchM2K1SourcingService.openSnackBar('Entity Chart update failed. '+error.error.errorMessage, 'gtw-snackbar--red'); },
        () => { console.log("Update Completed");this.isLoading =false; }
      );
      this.subs.add(updateSubscription);

    }
    else {
      this.f8865SchM2K1SourcingService.openSnackBar('Validation Error: . '+ this.validationErrMsg, 'gtw-snackbar--yellow');
    }

  }

  validate() {

    let isValid: boolean = true;
    let record: any = {};
    let issueIdList: any = [];

    this.validationErrMsg = '';

    for(let i = 0; i < this.clob_data.length; i++) {
      record = this.clob_data[i];
      console.log('record = ', record);
      if (record.ISSUE_KEY === -1) {
        isValid = false;
        this.validationErrMsg = 'Please select issue from the dropdown for record: ' + toNumber(i+1) + '' ;
        break;
      }
      else if(record.GENERAL+'' === '0' && record.FSI+'' === '0' && record.PASSIVE+'' === '0' && record.US+'' === '0') {
        isValid = false;
        this.validationErrMsg = 'At least one of GENERAL, FSI, PASSIVE or US basket amount should be non-zero for record '+ toNumber(i+1) + '';
        break;
      }
    }
    if ( this.validationErrMsg === '') {
      for(let i = 0; i < this.sourcingList.length; i++) {
        record = this.sourcingList[i];
        if(record.ISSUE_KEY !== 0)
          issueIdList.push(record.ISSUE_KEY);
      }

      if(this.checkForDuplicates(issueIdList) === true) {
        isValid = false;
        this.validationErrMsg = 'Duplicate Issue(s) selected for saving, Please check.';

      }
    }

    return isValid;
  }

  checkForDuplicates(array:any) {
    return new Set(array).size !== array.length
  }

  modalClose() {
    this.requestGridUpdate.emit('cancel');
    this.openSourcingBasketList.emit('open-sourcing-basket-list');
  }


  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
